import {createFileRoute} from '@tanstack/react-router';

import {ReimbursementDetailPage} from '@/modules/reimbursements/pages/ReimbursementDetailPage';

const RouteComponent = () => {
  const {reimbursementId} = Route.useParams();
  return <ReimbursementDetailPage reimbursementId={reimbursementId} />;
};

export const Route = createFileRoute('/_authenticated/reimbursements/$reimbursementId')({
  component: RouteComponent,
});
